import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const reverseComplementTool: Tool = {
  id: "reverse-complement",
  name: () => m.revcomp_tool_name(),
  description: () => m.revcomp_tool_description(),
  icon: "🧬",
  basePath: "/reverse-complement",
  status: "stable",
  tags: [
    "bioinformatics",
    "dna",
    "rna",
    "sequence",
    "science",
    "molecular-biology",
  ],
};
